import React, { Component } from "react";
import ButtonIcon from '../../components/button.js';
import CurrentDate from "../common/date/currentdate.component.js";
import Icons from "../icon";
import { Status_Data, Status_BG_Data } from "../../constants/internal-constants.js";
export class StatusData extends Component {
  constructor(props) {
    super(props);
    this.state={
      newDate:new Date
    }
  }
  RefreshData() {
    this.setState({newDate: new Date})
  }

  statusClassName(key, i) {
    const disabledClass = key !== Status_Data.Failed &&
                        key !== Status_Data.Rejected &&
                        key !== Status_Data.Open &&
                        key !== Status_Data.InProgress &&
                        key !== Status_Data.Pending &&
                        key !== Status_Data.Closed &&
                        key !== Status_Data.Approved &&
                        key !== Status_Data.Total ? 'disabled' : '';
    return disabledClass;
    
  }


  render() {
    return (
      <div className="status-data">
        <div className="header-status-data-container">
          <div className="header-date-container">
            <Icons
                name="arrow-rotate-light"
                size="18px"
                customClassName="icon-date-refresh"
                onClick={this.RefreshData.bind(this)}
            />
            <CurrentDate newdate={this.state.newDate}/>
          </div>
          
          <div className="statusData-button-container">
              <ButtonIcon onClick={()=>alert("click")} iconLeft="cloud-arrow-down" iconSize="14px" customClassName="extract-button" labelName="Extract Report"/>
            </div>
        </div>
        <div className="statusData-wrapper">         
          {this.props.data.map((value)=>{
           
            return(
              Object.keys(value).map((key,i)=>
                <div key={i} className={`statusData-Container ${this.statusClassName(key,i)}`}>
                  <div className="statusData-cont">
                    <div className="statusData-inner-container">
                      <div className={`statusData-fill ${Status_BG_Data[key] || 'bg-light-gray'}`}> </div>
                      <div className="data-wrapper">                 
                        <div className="statusData-value" key={i}> 
                          <span className={`value-count`}>{value[key]}</span> 
                          <span className="statusData-status">{key}</span>
                        </div>
                      </div> 
                    </div>  
                  </div>
                </div>
              )
            )
          })}
        </div>
        <div className="div-separator"></div>
      </div>
    );
  }
}